import { authRequest } from './index.js'

export async function get_terms(term_taxonomy, include = { exist: false, name: '' }){
  let data
  let url = 'term-taxonomy/' + term_taxonomy
  if (include.exist){
    url = 'term-taxonomy/' + term_taxonomy 
          + '?include=term_relationship'
          + '&object_type=' + include.name
  }
  await authRequest.get(
    url
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_term(term_id){
  let data
  await authRequest.get(
    'terms/' + term_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}